<template>
    <div>
        <el-card>
            <!-- 查询条件 -->
            <el-row>
                <el-col style="margin-right:6px;" :span="3">
                    <el-select size="small" v-model="KPIType" placeholder="请选择" @change="selectKPIType">
                        <el-option label="部门" value="0"></el-option>
                        <el-option label="岗位" value="1"></el-option>
                        <el-option label="个人" value="2"></el-option>
                    </el-select>
                </el-col>
                <el-col :class="KPITypeValue==0?'show':'hidden'" :span="3">
                    <el-select size="small" v-model="frameName" placeholder="请选择部门">
                        <el-option v-for="item in frameList" :key="item.Id" :label="item.ClassName" :value="item.Id"></el-option>
                    </el-select>
                </el-col>                
                <el-col :class="KPITypeValue==1?'show':'hidden'" :span="3">
                    <el-select size="small" v-model="dutyName" placeholder="请选择岗位">
                        
                        <el-option v-for="item in dutyList" :key="item.Id" :label="item.Duty" :value="item.Id"></el-option>
                        <!-- <el-option label="Q1" value="Q1"></el-option>
                        <el-option label="Q2" value="Q2"></el-option>
                        <el-option label="Q3" value="Q3"></el-option>
                        <el-option label="Q4" value="Q4"></el-option> -->
                    </el-select>
                </el-col>
                <el-col style="margin-right:6px;" :class="KPITypeValue==2?'show':'hidden'" :span="3">
                    <el-input size="small" clearable v-model="name" placeholder="请输入姓名"></el-input>
                </el-col>
                <el-col :span="2">
                    <el-button icon="el-icon-search" size="small" @click="SearchByName"></el-button>
                </el-col>
            </el-row>
            <el-row>
                <!-- 考核列表信息  show-summary :summary-method="getSummaries"-->
                <el-table border :data="userKPIList" style="width: 100%;margin-top:20px;" v-loading="loading" size="small">
                    <el-table-column label="周期类型">
                        <template slot-scope="scope">{{ scope.row.PeriodType==0?'月度':'季度' }}</template>
                    </el-table-column>
                    <el-table-column prop="Period"  label="周期"></el-table-column>
                    <el-table-column prop="KPI"  label="类别">
                        <template slot-scope="scope">
                            {{ scope.row.ItemType==0?'部门':(scope.row.ItemType==1?'岗位':'个人') }}
                        </template>
                    </el-table-column>
                    <el-table-column prop="KeyName" label="名称"></el-table-column>
                    <el-table-column prop="TrueName" label="操作人"></el-table-column>
                    <!-- <el-table-column label="KPI类型">
                        <template slot-scope="scope">
                            {{scope.row.KPIType == 0 ? "职能" : (scope.row.KPIType == 1 ? "业绩" : (scope.row.KPIType == 2 ? "自定义" : (scope.row.KPIType == 3 ? "其它" : (scope.row.KPIType == 4 ? "内部管理指标" : (scope.row.KPIType == 5 ? "客户指标" : (scope.row.KPIType == 6 ? "敬业度" : (scope.row.KPIType == 7 ? "重点项目" : "团队管理")))))))}}
                        </template>
                    </el-table-column> -->
                    <el-table-column prop="CreateTime" label="添加时间"></el-table-column>
                    <el-table-column label="操作"  fixed="right" :span="8">
                    <template slot-scope="scope" >
                        <el-button type="text" @click='viewKPI(scope.row)'>查看</el-button>

                        <!-- <el-button v-if="currentRole.Key=='admin'||currentRole.Key=='CEO'" type="text" @click='bindKPISet(scope.row)'>编辑</el-button> -->
                    </template>
                </el-table-column>
                </el-table>
            </el-row>
            <!-- 分页数据列表 -->
            <el-row>
                <el-pagination
                    @size-change="handleSizeChange"
                    @current-change="handleCurrentChange"
                    :current-page="pageIndex"
                    :page-sizes="pageSizes"
                    :page-size="pageSize"
                    layout="total, sizes, prev, pager, next, jumper"
                    :total="totalCount"
                    style="float:right"
                ></el-pagination>
            </el-row>


            <el-dialog width="70%" :title="dialagTitle" :visible.sync="dialogVisible">
                <div class="viewKPITitle">
                    <el-row>
                    <el-col :span="6">
                        <span>类型：{{ItemTypeFomartter(viewKPITitle.ItemType)}}</span>
                    </el-col>
                    <el-col :span="6">
                        <span>名称：{{viewKPITitle.KeyName}}</span>
                    </el-col>
                    </el-row>
                    <el-row>
                    <el-col :span="6">
                        <span>周期类型：{{PeriodTypeFormatter(viewKPITitle.PeriodType)}}</span>
                    </el-col>
                    <el-col :span="6">
                        <span>周期：{{viewKPITitle.Period}}{{viewKPITitle.PeriodType==1?'季度':'月'}}</span>
                    </el-col>
                    </el-row>
                </div>
                <el-divider></el-divider>
                <el-table :data="KPIItems" show-summary style="width: 100%" v-loading="loading" size="small">
                    <el-table-column min-width="100" prop="KPIType" :formatter="KPITypeFomartter" label="KPI类型"></el-table-column>
                    <el-table-column min-width="100" prop="KPI" label="KPI名称"></el-table-column>
                    <el-table-column min-width="50" prop="KPIWeight" label="KPI权重"></el-table-column>
                    <el-table-column min-width="200" prop="Explain" label="指标说明"></el-table-column>
                    <el-table-column min-width="250" prop="Contents" label="考核细则"></el-table-column>
                </el-table>
                <span slot="footer" class="dialog-footer">
                    <el-button type="primary" v-if="currentRole.Key=='admin'||currentRole.Key=='CEO'" @click="EditKPI">编辑</el-button>
                </span>
            </el-dialog>

            <EditKPIItem
                ref="detailDialog"
                :_list="KPIItems"
                :_currentDeptId="currentChargeDept"
                :_isAdd="isAdd"
                :_dialogVisible.sync="dialogVisible"
                :_dialogEditVisible.sync="dialogEditVisible"
                :_editDialogTitle="editDialogTitle"
            ></EditKPIItem>
        </el-card>
    </div>
</template>
<script>
import { Decrypt } from "../../until/ZeusApiSDK/Logic/CryptoLogic"; 
import { getUrlKey  } from "../../until/ZeusApiSDK/Logic/ImageStr";
import { GetFrameListByPid,GetDutysByFrameId  } from "../../until/ZeusApiSDK/Logic/StructureLogic";
import { GetItemListByInfoPC,ViewKPIDetail  } from "../../until/ZeusApiSDK/Logic/KPILogic";
import EditKPIItem from "../KPI/EditKPIItem";
export default {
    data(){
        return{
            currentUser:{},//当前用户
            currentRole:{},//当前用户角色
            loading:false,
            userKPIList:[],//员工KPI列表
            frameid:'',//部门id
            infoId:'',//信息id
            KPIType:'',//选择查询类型
            KPITypeValue:'',//判断显示后面条件
            frameList:[],//部门列表
            dutyList:[],//岗位列表
            frameName:'',//部门名称
            dutyName:'',//岗位名称
            name:'',//个人姓名
            pageSizes: [10, 20, 50, 100, 200],
            pageSize: 10,
            pageIndex: 1,
            totalCount: 0,
            dialogVisible: false,
            dialogEditVisible: false,
            dialagTitle: "设置详情",
            viewKPITitle: {},
            KPIItems: [],
            currentChargeDept: "",
            isAdd: true,
            editDialogTitle: "编辑KPI",
        }
    },
    created(){
        //部门id
        this.frameid=getUrlKey('frameid');
        //查看KPIid
        this.infoId=getUrlKey('infoId');

        //获取当前用户
        this.getCurrentUser();
        //获取当前用户角色
        this.getCurrentRole();

        //根据父级ID获取部门列表
        this.GetFrameListByPid();
        //根据部门ID获取部门下所有岗位
        this.GetDutysByFrameId();
        //获取KPI设置列表
        this.GetItemListByInfoPC();
    },
    methods:{
        //获取当前用户
        getCurrentUser:function(){
            var userinfo = window.sessionStorage.getItem("userinfo");
            userinfo = JSON.parse(Decrypt(userinfo));
            this.currentUser = userinfo;
        },
        //获取当前用户角色
        getCurrentRole:function(){
            var currentUserRole = window.sessionStorage.getItem("CurrentUserRole");
            this.currentRole = JSON.parse(Decrypt(currentUserRole));
        },
        //搜索条件
        SearchByName:function(){
            //获取KPI设置列表
            this.GetItemListByInfoPC();
        },
        //获取KPI设置列表
        GetItemListByInfoPC:function(){
            var searchText='';
            if(this.KPITypeValue==0){
                //显示部门
                searchText=this.frameName;
            }else if(this.KPITypeValue==1){
                //显示岗位
                searchText=this.dutyName;
            }
            else if(event==2){
                //显示姓名
                searchText=this.name;
            }
            GetItemListByInfoPC(this.currentRole.Key,this.name,this.dutyName,this.frameName,this.KPITypeValue,this.infoId,this.pageIndex,this.pageSize).then(res=>{
                
                this.userKPIList=res.List;
                this.totalCount=res.TotalCount;
            })
        },
        //根据父级ID获取部门列表
        GetFrameListByPid:function(){
            GetFrameListByPid(this.frameid).then(res=>{
                this.frameList=res.list;
            });
        },
        //根据部门ID获取部门下所有岗位
        GetDutysByFrameId:function(){
            GetDutysByFrameId(this.frameid).then(res=>{
                this.dutyList=res.list;
            });
        },
        //搜索条件选择
        selectKPIType:function(event, item){
            if(event==0){
                //显示部门
                this.KPITypeValue=0;
            }else if(event==1){
                //显示岗位
                this.KPITypeValue=1;
            }
            else if(event==2){
                //显示姓名
                this.KPITypeValue=2;
            }
            else{
                //全部隐藏
                this.KPITypeValue=''
            }
        },
        //分页条件搜索
        handleSizeChange(val) {
            this.pageSize = val;
            this.getAuditKPIList();
        },
        handleCurrentChange(val) {
            this.pageIndex = val;
            this.getAuditKPIList();
        },
        //详情
        viewKPI: function(row) {
            this.dialogVisible = true;
            ViewKPIDetail(row.Id).then(res => {
                this.KPIItems = res;
                this.KPIItems.forEach(element => {
                element.Contents = element.Contents.replace(/\ +/g, "").replace(
                    /[\n]/g,
                    ""
                );
            });
            this.viewKPITitle = res[0];
            });
        },
        EditKPI: function() {
            this.isAdd = false;
            this.editDialogTitle = "编辑KPI";
            this.dialogVisible = false;
            this.dialogEditVisible = true;
        },
        AddKPI: function() {
            this.isAdd = true;
            this.editDialogTitle = "添加KPI";
            this.KPIItems = [];
            this.dialogEditVisible = true;
            //由于接口延迟需重新为当前部门赋值
            this._currentDeptId=this.currentChargeDept;
            this.$refs.detailDialog.loadDialogData(this._currentDeptId);
        // this.$refs.refDialog.loadDialogData(this._currentDeptId);
        },
        ItemTypeFomartter(row, column, cellValue, index) {
            if (cellValue == 0) {
                return "部门";
            } else if (cellValue == 1) {
                return "岗位";
            } else {
                return "个人";
            }
        },
        PeriodTypeFormatter(row, column, cellValue, index) {
            if (cellValue == 1) {
                return "季度";
            } else {
                return "月度";
            }
        },
        KPITypeFomartter(row, column, cellValue, index) {
            if (cellValue == 0) {
                return "职能指标";
            } else if (cellValue == 1) {
                return "业绩指标";
            } else if (cellValue == 3) {
                return "自定义";
            } else if (cellValue == 4) {
                return "内部管理指标";
            } else if (cellValue == 5) {
                return "客户指标";
            } else if (cellValue == 6) {
                return "敬业度";
            } else if (cellValue == 7) {
                return "重点项目";
            } else if (cellValue == 8) {
                return "团队管理";
            } else {
                return "其他";
            }
        }
    },
    watch: {
        pt: {
        handler(n, o) {
            //n为新值,o为旧值;
            this.pType = n;
            this.GetSettingKPIPageList();
        },
        deep: true
        }
    },
    components: {
        EditKPIItem
    }
}
</script>